import api from "../Configuration/ApiConfig";

const BrandingService = {
  GetBranding: () => {
    const request = api.get('Branding/GetBranding')
    return request.then((response) => {
      return response.data
    })
  },
  AddBranding: (itemData) => {
    const request = api.post("Branding/CreateBranding", itemData);
    return request.then((response) => {
      return response.data;
    });
  },
  UpdateBranding: (itemData) => {
    const request = api.put("Branding/UpdateBranding", itemData);
    return request.then((response) => {
      return response.data;
    });
  }
}
export default BrandingService;